<template>
  <div v-if="items && items.length" class="u-documents-table">
    <div
      v-for="(item, idx) in items"
      :key="`${blockKey}-${idx}`"
      class="u-documents-table__row"
    >
      <div
        class="u-documents-table__col p1-medium"
        v-html="item.name"
      ></div>
      <div
        class="u-documents-table__col p1-medium"
        v-html="item?.props?.text"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TableDefaultTemplate',
  props: {
    blockKey: {
      type: String,
      default: 'def'
    },
    items: {
      type: Array,
      default() {
        return [];
      }
    }
  }
}
</script>